import { render, staticRenderFns } from "./default.vue?vue&type=template&id=a9d349c8&"
import script from "./default.vue?vue&type=script&lang=js&"
export * from "./default.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LayoutsHeader: require('/home/reformatorischeomroep/reformatorischeomroep/nuxt/components/layouts/Header.vue').default,IconsChevronRight: require('/home/reformatorischeomroep/reformatorischeomroep/nuxt/components/icons/ChevronRight.vue').default})
